import React, { useContext } from 'react'
import { EPCRContext } from './EPCR'
import EPCRCard from '../../../components/Cards/EPCRCard'
import { Button } from '@mui/material'
import { isFullLayoutMode } from './formTypes'

const NextButton = ({ newModule }) => {
  const { setSelectedEPCRModule, formValues } = useContext(EPCRContext)

  //TODO: Change naming convention of each module so that the module name can be updated from one place.
  if (!isFullLayoutMode(formValues.mode)) {
    return null
  }
  return (
    <EPCRCard>
      <Button
        fullWidth
        color="primary"
        variant="contained"
        onClick={() => setSelectedEPCRModule(newModule ?? 'Incident')}
      >
        Next
      </Button>
    </EPCRCard>
  )
}

export default NextButton
